<template>
  <div class="container">
    <div class="title0">
      <!-- 标题文字 -->
      <img :src="url + '/img/xaiofei/data1/bt.png'" class="titTxt" />
      <router-link :to="{ path: '/' }"
        ><img :src="url + '/img/xaiofei/sy.png'" class="return return1"
      /></router-link>
      <img
        :src="url + '/img/xaiofei/fh.png'"
        class="return return2"
        @click="clickReturn"
      />
      <img :src="url + '/img/zhibo/gx.png'" class="guang1" />
      <img :src="url + '/img/zhibo/gx.png'" class="guang2" />
    </div>
    <div class="content">
      <!-- 大的左侧 -->
      <div class="big_left">
        <!-- 小左边1 -->
        <div class="left animate__animated animate__slideInLeft">
          <!-- 左上 -->
          <div class="leftBox flexColumn">
            <!-- 左一 -->
            <div class="leftBox1 flexColumn">
              <div class="subTit">各类产品销量占比</div>
              <div class="leftContent leftContent1">
                <div class="leftContent1A">
                  <div
                    class="leftContent1Item"
                    v-for="(item, index) in leftData1"
                    :key="index"
                  >
                    <leftPie :rate="item.percent" :title="item.name" />
                  </div>
                </div>
                <router-link :to="{ path: '/xiaofeiChanpin' }"></router-link>
              </div>
              <!-- 左二 -->
            </div>
            <!--end 左上 -->
            <!-- 左中 -->
            <div class="leftBox2 flexColumn">
              <div class="leftContent2 flexColumn">
                <div class="leftContent2Box flexColumn">
                  <leftBar
                    :datas="leftData2[leftTitCurIndex]"
                    v-if="left2Show"
                  />
                </div>
              </div>
            </div>
            <!-- end左中 -->
            <!-- 左三 -->
            <div class="leftBox3">
              <div class="subTit">各类产品下单统计</div>
              <div class="leftContent leftContent3"><leftBar1 /></div>
            </div>
          </div>
          <!-- 小左结束 -->
        </div>

        <!-- 小左2开始 -->
        <div class="left animate__animated animate__slideInLeft">
          <!-- 小左2第二层div开始 -->
          <div class="leftBox flexColumn">
            <!-- 小左2的左一 开始-->
            <div class="leftBox1 flexColumn">
              <div class="subTit">销售分析</div>
              <div class="leftContent leftContent1">
                <div class="leftContent1B flexColumn">
                  <div class="leftContent1BTit">
                    <div
                      class="leftContent1BItem"
                      :class="{
                        leftContent1BItemCur: leftTitCurIndex == index,
                      }"
                      v-for="(item, index) in leftTit"
                      :key="index"
                      @click="left2Tab(index, 1)"
                    >
                      <span>{{ item }}</span>
                    </div>
                  </div>
                  <div class="leftContent1BContent">
                    <rightBar1
                      :datas="rightData1[leftTitCurIndex2]"
                      v-if="left2Show2"
                    />
                  </div>
                </div>
              </div>
              <!-- 小左2的左一 结束-->
            </div>
            <!-- 小左2的左一左二开始 -->
            <div class="leftBox2 flexColumn">
              <div class="leftContent2 flexColumn">
                <!-- 下单次数标题 开始-->
                <dive class="xiadan">
                  <span class="span1">下单总次数</span>
                  <span class="span2">289623</span>
                </dive>
                <!-- 下单次数标题结束 -->
                <div class="leftContent2Box flexColumn">
                  <rightBar2
                    :datas="rightData3[leftTitCurIndex3]"
                    v-if="left2Show3"
                  />
                </div>
              </div>
            </div>
            <!-- 小左2的左一左二结束 -->
            <!-- 小左2的左三开始 -->
            <div class="leftBox3">
              <div class="subTit">主播信息</div>
              <div class="leftContent leftContent3">
                <!-- 订单开始 -->
                <div class="ding_dan">
                  <span class="dan_s">订单</span>
                  <img class="dan_i" :src="url + '/img/zhibo/jbjx.png'" />
                </div>
                <!-- 订单结束 -->
                <!-- 滚动条开始 -->
                <div class="gun_dong">
                  <dv-scroll-board
                    :config="config"
                    style="width: 100%; height: 100%; font-size: 30px"
                  />
                </div>
                <!-- 滚动条结束 -->
              </div>
            </div>
            <!-- 小左2的左三结束 -->
            <!-- 小左2第二层div结束 -->
          </div>

          <!-- 左2结束 -->
        </div>
      </div>
      <!--大中间中间地图  -->
      <div class="big_center">
        <!-- 标题开始 -->
        <div class="big_center_bt">当前直播</div>
        <!-- 标题结束 -->
        <!--中间地图  -->
        <div class="center">
          <!-- <div class="subTit"></div> -->
        </div>
      </div>

      <!-- 大右侧 -->
      <div class="big_right">
        <!-- 小右侧1 -->
        <div class="right animate__animated animate__slideInRight">
          <div class="rightBox flexColumn">
            <!-- 小右侧1右一 -->
            <div class="rightBox1 flexColumn">
              <div class="subTit">产品信息</div>

              <!-- 小右侧1右一内容开始 -->
              <router-link :to="{ path: '/sanchan1' }">
              <div class="chan_ping">
                <div
                  class="chan_ping_bg"
                  v-for="(item, index) in chan_ping_data"
                  :key="index"
                >
                  <img class="chan_ping_tu" :src="item.header" />
                  <span class="chan_ping_name">{{ item.name }}</span>
                </div>
                
              </div>
              </router-link>

              <!-- 小右侧1右一内容end -->
            </div>
            <!-- end小右侧1右一 -->
            <!-- 小右侧1右二 -->
            <div class="rightBox2 flexColumn">
              <div class="subTit">订单列表</div>
              <div class="leftContent leftContent3 youbian1">
                <!-- 订单开始 -->
                <div class="ding_dan">
                  <span class="dan_s">订单</span>
                  <img class="dan_i" :src="url + '/img/zhibo/jbjx.png'" />
                </div>
                <!-- 订单结束 -->
                <!-- 滚动条开始 -->
                <div class="gun_dong">
                  <dv-scroll-board
                    :config="config1"
                    style="width: 100%; height: 100%; font-size: 30px"
                  />
                </div>
                <!-- 滚动条结束 -->
              </div>
            </div>

            <!-- end小右侧1右二 -->
            <!-- 小右侧1右3 -->

            <div class="rightBox2 rightBox4 flexColumn">
              <div class="rightTit">
                <span>直播间留言</span
                ><img :src="url + '/img/zhibo/jbjx.png'" />
              </div>
              <txtScroll class="rightContent2">
                <div
                  v-for="(item, index) in rightData2"
                  :key="index"
                  class="scroll_item"
                >
                  <span>{{ index + 1 }}</span
                  ><span>{{ item.content }}</span
                  ><span>{{ item.user }}</span>
                </div>
              </txtScroll>
            </div>
          </div>
          <!-- end小右侧1右3 -->
        </div>

        <!-- 小右侧2 -->
        <div class="right animate__animated animate__slideInRight">
          <div class="rightBox flexColumn">
            <!-- 右一 -->
            <div class="rightBox1 flexColumn">
              <div class="subTit">GMV趋势</div>
              <div class="gmv_qu_shi">
                <RightLine />
              </div>
            </div>
            <!-- 右二 -->
            <div class="rightBox2 flexColumn">
              <div class="subTit">销售完成率</div>
              <leftPie1 />
            </div>
            <!-- 右三 -->
            <div class="rightBox2 flexColumn">
              <div class="subTit">投诉与建议</div>
              <div class="tuo_shu">
                <div class="zuo_bian_tu_biao">
                  <img
                    src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/ts.png"
                  />
                </div>
                <h4>已处理</h4>
              </div>
              <div class="you_bian_nier">
                <dv-scroll-board
                  :config="config2"
                  style="width: 100%; height: 100%; font-size: 30px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer1 />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import leftPie from "../components/zhibo/leftPie";
import leftBar from "../components/zhibo/leftBar";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue";
import leftBar1 from "../components/zhibo/leftBar1";
import RightLine from "../components/zhibo/RightLine";
import rightBar1 from "../components/zhibo/rightBar1";
import rightBar2 from "../components/zhibo/rightBar2";
import centerLine from "../components/zhibo/centerLine";
import footer1 from "../components/footer.vue";
import leftPie1 from "../components/zhibo/leftPie1";
export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      leftData1: [
        { name: "小麦", number: 78.55, percent: "57.23%" }, //万吨
        { name: "玉米", number: 40.95, percent: "29.83%" },
        { name: "花生", number: 10.35, percent: "7.54%" },
        { name: "大豆", number: 1.5, percent: "1.09%" },
        { name: "芝麻", number: 1.1, percent: "0.8%" },
        { name: "红薯", number: 4.8, percent: "3.49%" },
      ],
      leftData2: [
        [
          { name: "A产品", percent: "58", total: "158111", finished: "82311" },
          { name: "B产品", percent: "76", total: "16522", finished: "9873" },
          { name: "C产品", percent: "98", total: "5823", finished: "5500" },
          { name: "d产品", percent: "58", total: "158111", finished: "82311" },
          { name: "e产品", percent: "76", total: "16522", finished: "9873" },
          { name: "f产品", percent: "98", total: "5823", finished: "5500" },
        ],
        [
          { name: "A产品", percent: "58", total: "15811", finished: "2311" },
          { name: "B产品", percent: "76", total: "122", finished: "873" },
          { name: "C产品", percent: "98", total: "583", finished: "5500" },
          { name: "d产品", percent: "58", total: "158111", finished: "82311" },
          { name: "e产品", percent: "76", total: "16522", finished: "9873" },
          { name: "f产品", percent: "98", total: "5823", finished: "5500" },
        ],
        [
          { name: "A产品", percent: "58", total: "15111", finished: "82311" },
          { name: "B产品", percent: "76", total: "1622", finished: "9873" },
          { name: "C产品", percent: "98", total: "823", finished: "5500" },
          { name: "d产品", percent: "58", total: "158111", finished: "82311" },
          { name: "e产品", percent: "76", total: "16522", finished: "9873" },
          { name: "f产品", percent: "98", total: "5823", finished: "5500" },
        ],
      ],
      leftTit: ["月度", "季度", "年度"],
      leftTitCurIndex: 0,
      leftTitCurIndex1: 0,
      leftTitCurIndex2: 0,
      leftTitCurIndex3: 0,
      left2Show: true,
      left2Show1: true,
      left2Show2: true,
      left2Show3: true,
      leftData3Tit: ["编号", "商品", "GMV", "订单数目"],
      leftData3: [
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
        { name: "XXX产品", price: "100", order: 458, unit: "吨" },
      ],
      endVal: 8888,
      options: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      rightData1: [
        [
          { name: "销售额", percent: "58", total: "158111", finished: "82311" },
          { name: "退单量", percent: "76", total: "16522", finished: "9873" },
        ],
        [
          { name: "销售额", percent: "58", total: "15811", finished: "2311" },
          { name: "退单量", percent: "76", total: "122", finished: "873" },
        ],
        [
          { name: "销售额", percent: "58", total: "15111", finished: "82311" },
          { name: "退单量", percent: "76", total: "1622", finished: "9873" },
        ],
      ],
      rightData2: [
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
        { content: "助力乡村振兴 大力发展电商直播平台", user: "用户1" },
      ],
      rightData3: [
        [
          { value: 335, name: "产品A" },
          { value: 1335, name: "产品B" },
          { value: 235, name: "产品C" },
          { value: 635, name: "产品D" },
          { value: 335, name: "产品E" },
          { value: 1335, name: "产品F" },
          { value: 235, name: "产品G" },
          { value: 635, name: "产品H" },
        ],
        [
          { value: 1335, name: "产品A" },
          { value: 335, name: "产品B" },
          { value: 635, name: "产品C" },
          { value: 835, name: "产品D" },
          { value: 1335, name: "产品E" },
          { value: 867, name: "产品F" },
          { value: 1035, name: "产品G" },
          { value: 635, name: "产品H" },
        ],
        [
          { value: 1335, name: "产品A" },
          { value: 1035, name: "产品B" },
          { value: 535, name: "产品C" },
          { value: 896, name: "产品D" },
          { value: 456, name: "产品E" },
          { value: 789, name: "产品F" },
          { value: 653, name: "产品G" },
          { value: 1125, name: "产品H" },
        ],
      ],
      rightData4: [
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "退款无法点击...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
        { content: "收到货包装有破损...", user: "用户1" },
      ],
      config: {
        header: [
          '<span style="color:#fff; font-size:30px;">排名</span>',
          '<span style="color:#fff;font-size:30px;">名称</span>',
          '<span style="color:#fff;font-size:30px;">粉丝量</span>',
        ],
        data: [
          [1, "乔师兄", "562.3万"],
          [2, "王铮铭0396", "189.4万"],
          [3, "一只小哥哥", "155.3万"],
          [4, "冬火火", "31.2万"],
          [5, "大姐姐", "29.3万"],
          [6, "仁义哥传媒", "28.5万"],
          [7, "郏卫军", "27.3万"],
          [8, "天伦华叔", "24.3万"],
          [9, "乡村小嫂子", "17.8万"],
          [10, "李美丽", "15.3万"],
        ],
        headerBGC: "",
        oddRowBGC: "#04232C",
        evenRowBGC: "",
        headerHeight: 50, // index: true,
        columnWidth: [150],
        align: ["center", "center", "center"], // rowNum:6
      },
      config2: {
        header: [
          '<span style="color:#fff; font-size:30px;">序号</span>',
          '<span style="color:#fff;font-size:30px;">客户</span>',
          '<span style="color:#fff;font-size:30px;">述求</span>',
        ],
        data: [
          [1, "乔师兄", "562.3万"],
          [2, "王铮铭0396", "189.4万"],
          [3, "一只小哥哥", "155.3万"],
          [4, "冬火火", "31.2万"],
          [5, "大姐姐", "29.3万"],
          [6, "仁义哥传媒", "28.5万"],
          [7, "郏卫军", "27.3万"],
          [8, "天伦华叔", "24.3万"],
          [9, "乡村小嫂子", "17.8万"],
          [10, "李美丽", "15.3万"],
        ],
        headerBGC: "",
        oddRowBGC: "#04232C",
        evenRowBGC: "",
        headerHeight: 50, // index: true,
        columnWidth: [150],
        align: ["center", "center", "center"], // rowNum:6
      },
      config1: {
        header: [
          '<span style="color:#fff; font-size:30px;">编号</span>',
          '<span style="color:#fff;font-size:30px;">商品</span>',
          '<span style="color:#fff;font-size:30px;">GMV</span>',
          '<span style="color:#fff;font-size:30px;">订单数目</span>',
        ],
        data: [
          [1, "丝瓜", "562.3万", 5000],
          [2, "红薯", "189.4万", 5000],
          [3, "黄姜", "155.3万", 5000],
          [4, "食用菌", "31.2万", 5000],
          [5, "酒", "29.3万", 5000],
          [6, "醋", "28.5万", 5000],
          [7, "丝瓜", "27.3万", 5000],
          [8, "丝瓜", "24.3万", 5000],
          [9, "丝瓜", "17.8万", 5000],
          [10, "丝瓜", "15.3万", 5000],
        ],
        headerBGC: "",
        oddRowBGC: "#04232C",
        evenRowBGC: "",
        headerHeight: 50, // index: true,
        columnWidth: [150],
        align: ["center", "center", "center", "center"], // rowNum:6
      },
      chan_ping_data: [
        { name: "丝瓜", header: require("../assets/img/zz.png") },
        { name: "红薯", header: require("../assets/img/zz.png") },
        { name: "黄姜", header: require("../assets/img/zz.png") },
        { name: "食用菌", header: require("../assets/img/zz.png") },
        { name: "酒", header: require("../assets/img/zz.png") },
        { name: "醋", header: require("../assets/img/zz.png") },
      ],
    });
    onMounted(() => {
      // setInterval(()=>{
      //   state.endVal = 87662
      // },5000)
    });
    onUnmounted(() => {
      // 清理资源
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    // 左側切換
    function left2Tab(index, index1) {
      console.log(index1);
      // 左一--销量占比
      if (index1 == 1) {
        this.left2Show = false; // 点击后先隐藏div
        state.leftTitCurIndex = index;
        setTimeout(() => {
          this.left2Show = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      } else if (index1 == 2) {
        // 左二--订单列表
        this.left2Show1 = false; // 点击后先隐藏div
        state.leftTitCurIndex1 = index;
        setTimeout(() => {
          this.left2Show1 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      } else if (index1 == 3) {
        // 右一--销售分析
        this.left2Show2 = false; // 点击后先隐藏div
        state.leftTitCurIndex2 = index;
        setTimeout(() => {
          this.left2Show2 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      } else {
        // 右二--直播间销量排行
        this.left2Show3 = false; // 点击后先隐藏div
        state.leftTitCurIndex3 = index;
        setTimeout(() => {
          this.left2Show3 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      }
    }
    // left2Tab2
    return {
      ...toRefs(state),
      clickReturn,
      left2Tab,
    };
  },
  components: {
    leftPie,
    leftBar,
    txtScroll,
    leftBar1,
    RightLine,
    rightBar1,
    rightBar2,
    countTo,
    centerLine,
    footer1,
    leftPie1,
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/font/DS-DIGIT.TTF");
}
::v-deep .row-item {
  font-size: 30px !important;
}

/* 选中第一个段落 */
::v-deep .row-item > .ceil:first-child {
  color: #f0bd26;
}

/* 选中第二个段落 */
::v-deep .row-item > .ceil:nth-child(2) {
  color: #00d7e1;
}

/* 选中最后一个段落 */
::v-deep .row-item > .ceil:last-child {
  color: #4df5b0;
}

.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/bj.png")
    no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .title0 {
    width: 100%;
    height: 554px;

    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/btbj.png")
      no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    .titTxt {
      width: 2347px;
      height: 93px;
      position: absolute;
      top: 36px;
      left: 50%;
      margin-left: -1173.5px;
    }
    .return {
      width: 81px;
      height: 38px;
      cursor: pointer;
      transform: scale(2);
      position: absolute;
      top: 100px;
    }
    .return1 {
      left: 100px;
    }
    .return2 {
      right: 100px;
    }
    .guang1 {
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2 {
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1 {
      0% {
        left: 0;
      }
      100% {
        left: 15%;
      }
    }
    @keyframes titleGuang2 {
      0% {
        right: 0;
      }
      100% {
        right: 15%;
      }
    }
  }

  .content {
    width: 100%;
    height: 100vh;
    display: flex;
    .flexColumn {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .subTit {
      width: 819px;
      height: 162px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/xbt.png")
        no-repeat 0 center;
      font-size: 38px;
      font-weight: normal;
      color: #fff;
      line-height: 45px;
      text-align: center;
      animation: subTit 2s linear infinite;
      position: absolute;
      line-height: 180px;
      // border: #f0bd26 1px solid;
      left: -12%;
      top: -110px;
      text-indent: 2.1em;
    }
    .more {
      position: absolute;
      right: 90px;
      top: 50px;
      color: #00d7e1;
      font-size: 14px;
      font-weight: bold;
    }
    .more1 {
      position: absolute;
      right: 100px;
      top: 192px;
      color: #00d7e1;
      font-size: 14px;
      font-weight: bold;
    }
    .leftContent1BTit {
      width: 100%;
      display: flex;
      height: 30px;
      justify-content: center;
      .leftContent1BItem {
        width: 120px;
        height: 60px;
        line-height: 60px;
        // box-shadow:0 0 10px 0 #047A72 inset;
        border: 2px solid rgba(4, 122, 144, 0);
        color: #fff;
        font-size: 28px;
        margin: 0 50px;
        transition: all 0.5s ease-out;
        cursor: pointer;
      }
      .leftContent1BItem:hover,
      .leftContent1BItemCur {
        border: 2px solid rgba(4, 122, 144, 1);
        border-radius: 10px;
        box-shadow: 0 0 20px rgb(4, 122, 114) inset, 0 0 16px rgb(4, 122, 114);
      }
    }

    .big_left {
      width: 1673px;
      // height: 1413px;
      height: 89%;
      display: flex;
      margin: 170px 40px 0 40px;
      // border: #f0bd26 1px solid;
    }
    .big_center {
      width: 2722px;
      // height: 1300px;
      height: 75%;
      margin: 0 50px;
      margin-top: 280px;
      // border: #f0bd26 1px solid;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/spk.png")
        no-repeat 0 center;
      background-size: 100% 100%;
      position: relative;
      .big_center_bt {
        width: 364px;
        height: 150px;
        font-size: 38px;
        color: #ffffff;
        position: absolute;
        left: 50%;
        top: 50px;
        margin-left: -182px;
      }
    }
    .big_right {
      width: 1673px;
      // height: 1413px;
      height: 89%;
      display: flex;
      margin: 170px 40px 0 40px;
      // border: #f0bd26 1px solid;
    }
    .left,
    .right {
      width: 792px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      background-color: #0a2339;
      margin: 0 20px;
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .left {
      .bg {
        transform: rotate(180deg);
      }
      .leftBox {
        position: absolute;
        left: 0;
        top: 95px;
        width: 100%;
        height: calc(100% - 95px);
        .leftContent {
          width: 100%;
          flex: 1;
        }
        .leftBox1,
        .leftBox2 {
          width: 100%;
          // border: #fff 1px solid;
        }
        // 左一
        .leftBox1 {
          .leftContent1 {
            display: flex;
            flex-direction: column;
            .leftContent1A {
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              height: 400px;
              .leftContent1Item {
                width: 240px;
                height: 200px;
                margin: 0 10px;
              }
            }
            .leftContent1B {
              flex: 1;
              width: 85%;
              margin-left: 5%;
              margin-top: 20px;
              .leftContent1BContent {
                width: 100%;
                // flex: 1;
                height: 200px;
                // border: #fff 1px solid;
              }
            }
          }
        }
        // 左二
        .leftBox2 {
          // height: 40%;
          max-height: 40%;
          min-height: 35%;
          .leftContent2 {
            width: 96%;
            flex: 1;
            overflow: hidden;

            .xiadan {
              width: 100%;
              height: 60px;
              .span1 {
                width: 50%;
                height: 100%;
                font-size: 28px;
                line-height: 60px;
                display: inline-block;
                text-align: right;
                background: linear-gradient(45deg, #03bbff, #4df5b0);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-weight: bold;
              }

              .span2 {
                width: 50%;
                height: 100%;
                font-size: 28px;
                color: #fff;
                line-height: 60px;
                display: inline-block;
                text-align: left;
                text-indent: 1em;
              }
            }
            .leftContent2Tit {
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 16px;
              span {
                display: block;
                font-size: 16px;
                background: linear-gradient(45deg, #03bbff, #4df5b0);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-weight: bold;
              }
              img {
                width: 257px;
                height: 13px;
                margin-top: 3px;
              }
            }
            .leftContent2Box {
              width: 100%;
              min-height: 70%;
              max-height: 88%;
              // height: 88%;
              // border: #f0bd26 1px solid;
              // flex: 1;
            }
          }
        }
        // 左三
        .leftBox3 {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          .leftContent3 {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            // border: 1px solid;

            .parent {
              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
            }

            .ding_dan {
              width: 100%;
              height: 40px;
              display: flex;
              margin-top: 30px;
              .dan_s {
                width: 60px;
                height: 40px;
                font-size: 28px;
                background: linear-gradient(45deg, #03bbff, #4df5b0);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                line-height: 40px;
                margin-left: 5%;
              }
              .dan_i {
                width: 334px;
                height: 20px;
                display: flex;
                justify-content: center; /* 水平居中 */
                align-items: center; /* 垂直居中 */
                margin-left: 338px;
                margin-top: 10px;
              }
            }

            .gun_dong {
              width: 100%;
              height: 460px;
              // border: 1px solid red;
              font-size: 30px;
            }
          }
        }
      }
    }
    .center {
      flex: 1;
      margin: 0 20px;
      position: relative;
    }
    .right {
      .rightBox {
        position: absolute;
        left: 0;
        top: 95px;
        width: 100%;
        height: calc(100% - 95px);
        .rightBox1 {
          width: 100%;
          height: 400px;
          margin-top: 30px;
          // border: 1px solid red;
          .chan_ping {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .chan_ping_bg {
              width: 262px;
              height: 120px;
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/cp.png")
                no-repeat 0 center;
              background-size: 100% 100%;
              position: relative;
              margin-top: 20px;
              .chan_ping_tu {
                width: 72px;
                height: 72px;
                // border: 1px solid #000;
                position: absolute;
                top: 20px;
                left: 20px;
              }
              .chan_ping_name {
                width: 120px;
                height: 50px;
                color: #fff;
                font-size: 30px;
                position: absolute;
                text-align: left;
                top: 37px;
              }
            }
          }
          .gmv_qu_shi {
            width: 100%;
            height: 360px;

            // border: 1px solid #fff;
          }
        }
        .rightBox2 {
          width: 100%;
          height: 500px;
          // border: 1px solid #000;
          margin-top: 70px;
          position: relative;
          .youbian1 {
            width: 100%;
            height: 100%;
          }
          .parent {
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center; /* 垂直居中 */
          }

          .ding_dan {
            width: 100%;
            height: 40px;
            display: flex;
            margin-top: 30px;
            .dan_s {
              width: 60px;
              height: 40px;
              font-size: 28px;
              background: linear-gradient(45deg, #03bbff, #4df5b0);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              line-height: 40px;
              margin-left: 5%;
            }
            .dan_i {
              width: 334px;
              height: 20px;
              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
              margin-left: 338px;
              margin-top: 10px;
            }
          }

          .gun_dong {
            width: 100%;
            height: 460px;
            // border: 1px solid red;
            font-size: 30px;
          }

          .rightTit {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin: 10px 0;
            span {
              display: block;
              font-size: 28px;
              background: linear-gradient(45deg, #03bbff, #4df5b0);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-weight: bold;
              text-indent: 2em;
            }
            img {
              width: 334px;
              height: 20px;
              margin-top: 3px;
            }
          }
          .rightContent2 {
            width: 100%;
            flex: 1;
            overflow: hidden;
            .scroll_item {
              width: 100%;
              height: 60px;
              font-size: 30px;
              display: flex;
              justify-content: space-between;
              span {
                display: block;
                width: 30%;
                font-size: 30px;
                color: #fff;
                line-height: 50px;
                text-align: center;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              span:nth-child(1) {
                width: 10%;
                color: #00ffc3;
                text-align: left;
              }
              span:nth-child(2) {
                width: 65%;
                color: #00d7e1;
                text-align: left;
              }
              span:nth-child(3) {
                width: 20%;
                color: #1dc2ff;
                text-align: right;
              }
            }
          }
        }
        .rightBox3 {
          width: 100%;
          flex: 1;
          .rightContent3 {
            width: 100%;
            flex: 1;
            .rightEchart3 {
              width: 100%;
              flex: 1;
            }
          }
        }
        .rightBox4 {
          ::v-deep .main_container {
            width: 100%;
            height: 300px;
          }
          .rightContent2 {
            .scroll_item {
              span:nth-child(1) {
                color: #1dc2ff;
              }
            }
          }
        }

        .tuo_shu {
          width: 156px;
          height: 100%;
          position: absolute;
          left: 20px;
          h4 {
            width: 100%;
            height: 60px;
            font-size: 25px;
            color: #fff;
            line-height: 60px;
            position: absolute;
            top: 260px;
          }
          .zuo_bian_tu_biao {
            width: 156px;
            height: 165px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/dszb/yq.png")
              no-repeat 0 center;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 90px;
            img {
              width: 60px;
              height: 65px;
              top: 50px;
              left: 58px;
              position: absolute;
            }
          }
        }
        .you_bian_nier {
          width: 630px;
          height: 80%;
          position: absolute;
          right: 0;
          top: 40px;
        }
      }
    }
  }
}
@keyframes titleGuang1 {
  0% {
    left: 0;
  }
  100% {
    left: 15%;
  }
}
@keyframes titleGuang2 {
  0% {
    right: 0;
  }
  100% {
    right: 15%;
  }
}
@keyframes subTit {
  0% {
    transform: rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: rotate(1deg);
    opacity: 0.8;
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-1deg);
    opacity: 0.8;
  }
}

@keyframes line {
  0% {
    width: 0;
  }
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50% {
    width: 96%;
  }
  100% {
    width: 0;
  }
}
@keyframes bianda {
  0% {
    filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  }
  50% {
    filter: drop-shadow(0 0 5px rgba(35, 151, 157, 1));
  }
  100% {
    filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  }
}
@keyframes daxiao {
  0% {
    transform: scale(0.96);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.96);
  }
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@keyframes rightDaxiao {
  /*引用动画名称*/
  0% {
    transform: scale(0.96);
    transform: rotate(0);
  }
  50% {
    transform: scale(1.1);
    transform: rotate(20deg);
  }
  100% {
    transform: scale(0.96);
    transform: rotate(0deg);
  }
}
@keyframes rightDaxiao1 {
  /*引用动画名称*/
  0% {
    width: 0;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 0;
  }
}
</style>
